export enum AllowedCountriesEnum {
  //COLOMBIA = "CO",
  VENEZUELA = "VE",
  ECUADOR = "EC",
  PERU = "PE",
}